export default __webpack_public_path__ + "static/media/10t.e5db45ae.jpg";